import * as React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      fill={fill}
      fillRule="evenodd"
      d="M12 21.6a9.6 9.6 0 1 1 0-19.2 9.6 9.6 0 0 1 0 19.2Zm-4.8-7.792c0 .085.07.162.165.162h.8a.17.17 0 0 0 .165-.162v-2.175h.966l1.156 2.26c.018.034.06.077.14.077h.912c.148 0 .209-.136.148-.247l-1.191-2.167c.756-.298 1.287-.938 1.287-1.722C11.748 8.819 10.896 8 9.852 8H7.365a.164.164 0 0 0-.165.162v5.646Zm1.139-3.087V9.023h1.417c.461 0 .861.376.861.828 0 .477-.4.87-.86.87H8.338Zm8.46 1.287c0-1.194-.825-2.064-1.92-2.064-.853 0-1.314.589-1.314.589l-.104-.316c-.035-.11-.096-.187-.191-.187h-.322a.191.191 0 0 0-.192.187v5.595c0 .094.087.188.192.188h.704c.096 0 .191-.094.191-.188v-1.91c.183.068.566.162.966.162 1.2 0 1.99-.904 1.99-2.056Zm-2.956-.545c.087-.222.366-.546.887-.546.626 0 .948.537.948 1.091 0 .555-.339 1.084-1 1.084a1.61 1.61 0 0 1-.835-.222v-1.407Z"
      clipRule="evenodd"
    />
  </g>
);

export default Icon;
